import PropTypes from "prop-types";
import React from "react";
import CommonDialog from "@/Components/Common/CommonDialog";
import { CSVLink } from "react-csv";

const ExportCSVModal = ({ show, onCloseClick, data }) => {
  const csvLinkRef = React.useRef<any>(null);

  return (
    <CommonDialog
      isOpen={show}
      onClose={onCloseClick}
      title="CSV 내보내기"
      description="CSV 파일을 내보내시겠습니까?"
      tone="warning"
      actions={[
        {
          label: "닫기",
          color: "light",
          closeOnClick: false,
          onClick: onCloseClick,
        },
        {
          label: "다운로드",
          color: "success",
          closeOnClick: false,
          onClick: () => {
            csvLinkRef.current?.link?.click();
            onCloseClick?.();
          },
        },
      ]}
    >
      <CSVLink
        data={data}
        className="d-none"
        ref={csvLinkRef}
      >
        download
      </CSVLink>
    </CommonDialog>
  );
};

ExportCSVModal.propTypes = {
  onCloseClick: PropTypes.func,
  data: PropTypes.any,
  show: PropTypes.any,
};

export default ExportCSVModal;
